import React from 'react';
import PropTypes from 'prop-types';
import { ShareButtons } from '@wix/wix-vod-shared/components';
import { getUrlToVideo, SHARE_MODES } from '@wix/wix-vod-shared/common';
import i18n from '../../../i18n';

class ShareVideoOverlay extends React.Component {
  static propTypes = {
    siteUrl: PropTypes.string,
    instanceInfo: PropTypes.object,
    channelData: PropTypes.object,
    videoItem: PropTypes.object,
    shouldShowLinkButton: PropTypes.bool,
    onMoreClicked: PropTypes.func,
    isRTL: PropTypes.bool,
  };

  static defaultProps = {
    onMoreClicked: () => {},
    shouldShowLinkButton: true,
  };

  getShareTranslations() {
    const { title } = this.props.videoItem;
    return {
      titleText: i18n.t('share-overlay.share.title'),
      twitterDescriptionText: i18n.t('share-overlay.share.twitter', {
        title,
        siteUrl: '{siteUrl}',
      }),
      linkCopiedText: i18n.t('share-overlay.share.link-copied-text'),

      // tooltips
      facebookTooltipText: i18n.t('share-overlay.share.tooltips.facebook'),
      twitterTooltipText: i18n.t('share-overlay.share.tooltips.twitter'),
      linkTooltipText: i18n.t('share-overlay.share.tooltips.link'),
      moreTooltipText: i18n.t('share-overlay.share.tooltips.more'),
    };
  }

  getShareAriaLabels() {
    return {
      facebookAriaLabel: i18n.t(
        'share-overlay.share.area-label.social-network',
        { network: 'Facebook' },
      ),
      twitterAriaLabel: i18n.t(
        'share-overlay.share.area-label.social-network',
        { network: 'Twitter' },
      ),
      linkAriaLabel: i18n.t('share-overlay.share.area-label.link'),
      moreAriaLabel: i18n.t('share-overlay.share.area-label.more'),
    };
  }

  getUrlToVideo() {
    const { videoItem, instanceInfo, siteUrl } = this.props;
    return getUrlToVideo(videoItem, {
      siteUrl,
      compId: instanceInfo.componentId,
    });
  }

  render() {
    const {
      channelData,
      videoItem,
      instanceInfo,
      shouldShowLinkButton,
      onMoreClicked,
      isRTL,
    } = this.props;
    return (
      <ShareButtons
        channelData={channelData}
        videoItem={videoItem}
        shareMode={SHARE_MODES.VIDEO}
        instanceInfo={instanceInfo}
        canShowSelect={false}
        shouldShowPinterestButton={false}
        shouldShowTumblrButton={false}
        shouldShowEmbedButton={false}
        shouldShowLinkButton={shouldShowLinkButton}
        shouldShowMoreButton
        videoUrl={this.getUrlToVideo()}
        onMoreClicked={onMoreClicked}
        isRTL={isRTL}
        {...this.getShareTranslations()}
        {...this.getShareAriaLabels()}
      />
    );
  }
}

export default ShareVideoOverlay;
